/** NextGen P1 — TSV clipboard helpers for Estimating Grid (Excel coexistence). */

export type EstimatingEditableField = 'quantity' | 'unit_rate' | 'description' | 'notes' | 'uom';

export function parseClipboardTsv(text: string): string[][] {
  const normalized = String(text || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  if (!normalized.trim()) return [];
  return normalized
    .split('\n')
    .filter((line, i, arr) => !(i === arr.length - 1 && line === ''))
    .map((line) => line.split('\t'));
}

export function toClipboardTsv(rows: Array<Array<string | number | null | undefined>>): string {
  return rows
    .map((r) =>
      r
        .map((c) => {
          const s = c == null ? '' : String(c);
          return s.includes('\t') || s.includes('\n') ? s.replace(/\t/g, ' ').replace(/\n/g, ' ') : s;
        })
        .join('\t')
    )
    .join('\n');
}

export function parseNumericCell(raw: string): { ok: true; value: number } | { ok: false; error: string } {
  const t = String(raw ?? '').trim().replace(/,/g, '');
  if (t === '') return { ok: false, error: 'Empty numeric value' };
  const n = Number(t);
  if (!Number.isFinite(n)) return { ok: false, error: `Not a number: ${raw}` };
  if (n < 0) return { ok: false, error: 'Negative values are not allowed' };
  return { ok: true, value: n };
}

export const PASTE_FIELD_ORDER: EstimatingEditableField[] = [
  'quantity',
  'unit_rate',
  'description',
  'uom',
  'notes',
];
